import React from 'react';
import loadable from 'utils/loadable';
import LoadingIndicator from 'components/LoadingIndicator';

export default loadable(() => import('./containers/SwVersionsGridContainer'), {
	fallback: <LoadingIndicator />,
});